export const STORE_NAME = 'core/block-editor';
